<template>

  <form action="" class="form-inline justify-content-center mb-5">
    <div class="form-group alias-form-group mr-sm-3 mb-2">
      <input type="text" class="form-control first-name-field" :class="{raised: type === 'raised', filled: firstName}" id="firstName" v-model="firstName" @input="onInput">
      <label for="firstName">{{ $t('aliasForm.label') }}</label>
      <div class="invalid-feedback" v-if="!valid">{{ $t('aliasForm.invalid') }}</div>
    </div>

    <g-recaptcha
      :data-btn-class="{'btn btn-red shadow-md mb-2': true, loading: loading}"
      data-sitekey="6Le9p2wUAAAAANQyQGToovGzSSDfEycw8DD9Hvlc"
      :data-validate="validate"
      :data-callback="callback"
      :data-btn-disabled="loading">
      <span class="btn-text">{{ $t('aliasForm.button') }}</span>
      <span class="spinner">
        <span class="bounce1"></span>
        <span class="bounce2"></span>
        <span class="bounce3"></span>
      </span>
    </g-recaptcha >
    </form>

</template>

<script>
import gRecaptcha from '@finpo/vue2-recaptcha-invisible'
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'alias-form',
  components: {
    'g-recaptcha': gRecaptcha
  },
  props: ['type'],
  data() {
    return {
      loading: false,
      valid: true
    }
  },
  computed: {
    ...mapFields({
      firstName: 'user.firstName'
    }),
  },
  methods: {
    validate() {
      if (this.validAlias(this.firstName)) {
        this.loading = true
        return true
      }
      this.valid = false
      this.loading = false
      grecaptcha.reset()
      return false
    },
    validAlias(alias) {
      const re = /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽÜÑa-záčďéěíňóřšťúůýžüñ ]{3,20}$/
      return re.test(alias.toLowerCase())
    },
    callback(token) {
      this.loading = true
      const validAlias = this.firstName.replace(/[^A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽÜÑa-záčďéěíňóřšťúůýžüñ]+/g, '')
      this.firstName = validAlias.replace(' ', '')
      if (token) {
        const formData = new FormData();
        formData.append('gtoken', token)
        formData.append('alias', this.firstName)
        formData.append('language', this.$i18n.locale)
        this.$store.dispatch('getTokenId', formData)
      } else {
        this.valid = false
      }
    },
    onInput() {
      this.valid = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .first-name-field {
    min-width: 270px;
  }

  .first-name-field {
    @media (min-width: 768px) {
      min-width: 330px;
    }
  }

  .gray-text {
    color: #71828f;
  }

  .alias-form-group {
    position: relative;
  }

  .invalid-feedback {
    position: absolute;
    bottom: -30px;
    left: 0;
    width: 100%;
    display: block;
    text-align: left;
  }
</style>
